"use strict";
// Typography
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spacing = exports.Typography = void 0;
exports.Typography = {
    sizes: {
        xs: '.625rem', // `10px`
        sm: '.75rem', // `12px`
        smd: '0.875rem',
        md: '1rem', // `16px`
        lg: '1.125rem', // `18px`
        xl: '1.5rem', // `24px`
        xxl: '2rem', // `32px`
    },
};
// Spacing
exports.Spacing = {
    sp1: '.25rem',
    sp2: '.5rem',
    sp3: '1rem',
    sp4: '1.5rem',
    sp5: '3rem',
    sp6: '4.5rem',
};
